import EmptyLayout from '@/views/layouts/EmptyLayout.vue';

export default [
    // {
    //     path: 'shop',
    //     name: 'shop',
    //     component: EmptyLayout,
    //     meta: { auth: true },
    //     children : [
    //         {
    //             path: 'shop/products',
    //             name: 'shop-products-list',
    //             meta:  { auth: true },
    //             component: () => import('@/modules/shop/products/views/ShopProductList.vue')
    //         },
    //         {
    //             path: 'shop/products/add',
    //             name: 'shop-products-add',
    //             meta:  { auth: true },
    //             component: () => import('@/modules/shop/products/views/ShopProductForm.vue')
    //         },
    //         {
    //             path: 'shop/products/edit/:id',
    //             name: 'shop-products-edit',
    //             meta:  { auth: true },
    //             component: () => import('@/modules/shop/products/views/ShopProductForm.vue')
    //         },
    //         {
    //             path: 'shop/products/categories',
    //             name: 'shop-products-categories',
    //             meta:  { auth: true },
    //             component: () => import('@/modules/shop/products/views/categories/ShopProductCategoryList.vue')
    //         },
    //         {
    //             path: 'shop/products/categories/add',
    //             name: 'shop-products-categories-add',
    //             meta:  { auth: true },
    //             component: () => import('@/modules/shop/products/views/categories/ShopProductCategoryForm.vue')
    //         },
    //         {
    //             path: 'shop/products/categories/edit/:id',
    //             name: 'shop-products-categories-edit',
    //             meta:  { auth: true },
    //             component: () => import('@/modules/shop/products/views/categories/ShopProductCategoryForm.vue')
    //         },
    //         {
    //             path: 'shop/products/labels',
    //             name: 'shop-labels-list',
    //             meta: { auth: true },
    //             component: () => import('@/modules/shop/labels/views/LabelsList.vue')
    //         },
    //         {
    //             path: 'shop/products/labels/add',
    //             name: 'shop-labels-add',
    //             meta: { auth: true },
    //             component: () => import('@/modules/shop/labels/views/LabelForm.vue')
    //         },
    //         {
    //             path: 'shop/products/labels/edit/:id',
    //             name: 'shop-labels-edit',
    //             meta: { auth: true },
    //             component: () => import('@/modules/shop/labels/views/LabelForm.vue')
    //         },
    //         {
    //             path: 'shop/orders',
    //             name: 'shop-orders-list',
    //             meta:  { auth: true },
    //             component: () => import('@/modules/shop/orders/views/ShopOrderList.vue')
    //         },
    //         {
    //             path: 'shop/orders/add',
    //             name: 'shop-orders-add',
    //             meta:  { auth: true },
    //             component: () => import('@/modules/shop/orders/views/ShopOrderForm.vue')
    //         },
    //         {
    //             path: 'shop/orders/edit/:id',
    //             name: 'shop-orders-edit',
    //             meta:  { auth: true },
    //             component: () => import('@/modules/shop/orders/views/ShopOrderForm.vue')
    //         },
    //         {
    //             path: 'shop/orders/configuration/numbering',
    //             name: 'shop-orders-numbering',
    //             meta:  { auth: true },
    //             component: () => import('@/modules/shop/orders/views/ShopOrderNumberingForm.vue')
    //         },
    //         {
    //             path: 'shop/configuration/currency',
    //             name: 'shop-currency',
    //             meta:  { auth: true },
    //             component: () => import('@/modules/shop/settings/currencies/views/ShopCurrencyForm.vue')
    //         },
    //         {
    //             path: 'shop/configuration/payments',
    //             name: 'shop-payments',
    //             meta: { auth: true },
    //             component: () => import('@/modules/shop/settings/payments/views/ShopPaymentsList.vue')
    //         },
    //         {
    //             path: 'shop/configuration/payments/:id',
    //             name: 'shop-payments-edit',
    //             meta: { auth: true },
    //             component: () => import('@/modules/shop/settings/payments/views/ShopPaymentForm.vue')
    //         },
    //         {
    //             path: 'shop/configuration/payments/add',
    //             name: 'shop-payments-add',
    //             meta: { auth: true },
    //             component: () => import('@/modules/shop/settings/payments/views/ShopPaymentForm.vue')
    //         },
    //         {
    //             path: 'shop/products/collections',
    //             name: 'shop-collections-list',
    //             meta: { auth: true },
    //             component: () => import('@/modules/shop/collections/views/ShopCollectionList.vue')
    //         },
    //         {
    //             path: 'shop/products/collections/add',
    //             name: 'shop-collections-add',
    //             meta: { auth: true },
    //             component: () => import('@/modules/shop/collections/views/ShopCollectionForm.vue')
    //         },
    //         {
    //             path: 'shop/products/collections/edit/:id',
    //             name: 'shop-collections-edit',
    //             meta: { auth: true },
    //             component: () => import('@/modules/shop/collections/views/ShopCollectionForm.vue')
    //         },
    //     ]
    // }
];
